module.exports = __webpack_public_path__ + "static/media/warning.22e5a4f6.png";